import React from 'react'
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { conceptsResponseTable } from '@cbgms/api/modules/customers'
import { makeStyles } from '@mui/styles'
import { useTranslation } from 'react-i18next'

interface ConceptsProps {
  cData: conceptsResponseTable | null
}

const useStyles = makeStyles(theme => ({
  tableCellHead: {
    textAlign: 'center',
    color: theme.palette.common.black,
    fontWeight: 'bold',
    border: `1px solid ${theme.palette.divider}`,
    padding: '0.5rem'
  },
  tableCellBody: {
    textAlign: 'center',
    fontSize: '0.875rem',
    border: `1px solid ${theme.palette.divider}`,
    padding: '0.5rem',
    height: '2.8125rem'
  },
  tableRowOdd: {
    backgroundColor: theme.palette.action.hover
  },
  tableRowLastChild: {
    border: `1px solid ${theme.palette.divider}`
  },
  tableContainer: {
    overflow: 'auto',
    height: '20.625rem',
    boxShadow: 'none'
  }
}))

const Concepts: React.FC<ConceptsProps> = ({ cData }) => {
  const classes = useStyles()
  const conceptsArray = cData || []
  const { t } = useTranslation()

  return (
    <TableContainer component={Paper} className={classes.tableContainer}>
      <Table stickyHeader aria-label='customized table'>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableCellHead}>{t('Concepts.ModuleId')}</TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('Concepts.ModuleName')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('Concepts.ContractStartDate')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('Concepts.ContractEndDate')}
            </TableCell>
            <TableCell className={classes.tableCellHead} align='right'>
              {t('Concepts.ModuleType')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {conceptsArray.map(row => (
            <TableRow key={row.ModuleId} className={Number(row.ModuleId) % 2 === 0 ? '' : classes.tableRowOdd}>
              <TableCell className={classes.tableCellBody} component='th' scope='row'>
                {row.ModuleId}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ModuleName}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ContractStartDate}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ContractEndDate}
              </TableCell>
              <TableCell className={classes.tableCellBody} align='right'>
                {row.ModuleType}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default Concepts
